import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

/** Avviso quando il tablet è senza rete: la shell resta visibile ma i dati non si aggiornano. */
export default function OssOfflineBanner() {
  const [offline, setOffline] = useState(() => typeof navigator !== "undefined" && navigator.onLine === false);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  if (!offline) return null;
  return (
    <div
      role="status"
      data-testid="oss-offline-banner"
      className="sticky top-0 z-50 flex min-h-[44px] items-center justify-center gap-2 bg-amber-100 px-4 py-2 text-sm font-medium text-amber-900 dark:bg-amber-900/60 dark:text-amber-100"
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden />
      Sei offline: ospiti, turni e consegne non si aggiornano finché la connessione non torna.
    </div>
  );
}
